export default __webpack_public_path__ + "static/media/seademo_infografica_it.273812bb.jpg";